import { AlertSpg, FormSection, GridContainer, GridItem, InputFormField } from "@duosoftbg/nacid-components";
import React from "react";
import StudiedSubjectFormFields from "./common/StudiedSubjectFormFields";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

const AdditionalStudiedSubjectFormSection = () => {
  const { t } = useTranslation();
  const hasOfficialNote = useWatch({ name: "hasOfficialNote" });

  if (!hasOfficialNote) {
    return null;
  }

  return (
    <FormSection label={"t.additional.studied.subjects"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem xs={12} sm={12} md={12}>
          <AlertSpg severity={"info"}>{t("m.additional.studied.subjects.info")}</AlertSpg>
        </GridItem>
      </GridContainer>
      <GridContainer spacing={3} mt={0}>
        <GridItem xs={12} sm={12} md={12}>
          <InputFormField
            required={false}
            fieldName={"additionalSubjects.additionalStudiedSubjectsNote"}
            labelCode={"l.additionalStudiedSubjects.note"}
          />
        </GridItem>
      </GridContainer>
      <StudiedSubjectFormFields baseField={"additionalSubjects.additionalStudiedSubjects"} includesClassYear={true} />
    </FormSection>
  );
};

export default AdditionalStudiedSubjectFormSection;
